import {ISearchItem} from "../definitions";
import {GO_CATEGORIES} from "../enums/e-game-objects";
import {DOCUMENT_TYPES} from "../enums/enums";


export function createObjectLink(item:ISearchItem):string[] {
  if (!item) {
    return [];
  }

  switch (item._type) {
    case DOCUMENT_TYPES.GO:
      switch (item.category) {
        case GO_CATEGORIES.COMMON_BUILDING:
        case GO_CATEGORIES.HOUSE:
        case GO_CATEGORIES.PASTURE:
        case GO_CATEGORIES.FARM_CELL:
        case GO_CATEGORIES.LAIR:
        case GO_CATEGORIES.STORAGE_COMMON:
        case GO_CATEGORIES.STORAGE_MANA:
          return ["/gameObjects/buildings"];

        case GO_CATEGORIES.ACHIEVEMENT_HOUSE:
          return ["/gameObjects/achievement_houses"];

        case GO_CATEGORIES.GARBAGE:
        case GO_CATEGORIES.TREE:
          return ["/gameObjects/garbage"];

        case GO_CATEGORIES.DECOR:
          return ["/gameObjects/decor"];

        case GO_CATEGORIES.LIVE_DECOR:
          return ["/gameObjects/live_decor"];

        case GO_CATEGORIES.ROAD:
          return ["/gameObjects/roads"];

        case GO_CATEGORIES.MARKET:
        case GO_CATEGORIES.SHOP_KEEPER:
        case GO_CATEGORIES.ZEPPELIN:
          return ["/gameObjects/special"];

        case GO_CATEGORIES.ANIMAL:
          return ["/gameObjects/animals"];

        case GO_CATEGORIES.PLANT:
          return ["/gameObjects/plants"];

        case GO_CATEGORIES.STUFF:
          return ["/gameObjects/resources"];

        case GO_CATEGORIES.STUFF_PACK:
          return ["/gameObjects/shop_lots"];

        case GO_CATEGORIES.LANDSCAPE:
          return ["/gameObjects/landscape"];

        case GO_CATEGORIES.SHMU:
          return ["/gameObjects/character"];

        case GO_CATEGORIES.SCAFFOLD, GO_CATEGORIES.BALLOONS, GO_CATEGORIES.DIRIGIBLE, GO_CATEGORIES.FLYING_CAT, GO_CATEGORIES.TALKING_HEAD:

          return ["/gameObjects/misc"];
      }
      return [];

    case DOCUMENT_TYPES.QUESTS: return ["/questsMain/quests"];
    case DOCUMENT_TYPES.QUEST_ARCS: return ["/questsMain/arcs"];
    case DOCUMENT_TYPES.PREM_SHOP_LOTS: return ["/premiumShop/lots"];
    case DOCUMENT_TYPES.OFFER_LOTS: return ["/premiumShop/offer-lots"];
    case DOCUMENT_TYPES.PREM_SHOP_LEVELS: return ["/premiumShop/levels"];
    case DOCUMENT_TYPES.BUFF: return ["/buffs"];
    case DOCUMENT_TYPES.SPELL: return ["/spells"];
    case DOCUMENT_TYPES.ACHIEVEMENT: return ["/achievements"];
    case DOCUMENT_TYPES.OFFER: return ["/offers"];
    case DOCUMENT_TYPES.LEVEL: return ["/attributes/levels"];
    case DOCUMENT_TYPES.DROP: return ["/attributes/drop"];
    case DOCUMENT_TYPES.SETTINGS: return ["/attributes/profile"];
    case DOCUMENT_TYPES.GENERATORS: return ["/location/generators"];
    case DOCUMENT_TYPES.MAP_REFS: return ["/location/maps"];
  }

  return [];
}


export function createObjectLinkQuery(item:ISearchItem) {
  if (!item) { return {}; }
  return { _id: item._id };
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/create-object-link.ts